import React, { useState, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import './AustinBikeMap.scss';

const FAQ_DATA = [
  {
    q: (
      <FormattedMessage
        id="ae-erides-bikemap-faq1"
        defaultMessage="Austin Bike Map "
      />
    ),
    a: (
      <div className="austinMap">
        <p>
          <FormattedMessage
            id="ae-erides-bikemap-faq1-a"
            defaultMessage="Explore Austin's growing bike lanes and trails."
          />
        </p>
        <iframe
          width="968"
          height="497"
          title="ERides Bike Map"
          src="https://austin.maps.arcgis.com/apps/webappviewer/index.html?id=c7fecf32a2d946fabdf062285d58d40c&extent=3052120.7123%2C10036958.1486%2C3179054.0456%2C10097891.4819%2C102739"
        />
      </div>
    ),
  },
  {
    q: (
      <FormattedMessage
        id="ae-erides-bikemap-faq2"
        defaultMessage="🚴 Try an E-Bike ‍⚡"
      />
    ),
    a: (
      <FormattedMessage
        id="ae-erides-bikemap-faq2A"
        defaultMessage="Not ready to buy? No problem. {link} lets you borrow an e-bike for rides around central Austin."
        values={{
          link: (
            <a
              href="https://www.capmetro.org/bikeshare"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FormattedMessage
                id="ae-erides-faq2A-bike-link"
                defaultMessage="Bikeshare"
              />
            </a>
          ),
        }}
      />
    ),
  },
];

const Chevron = ({ expanded }) => (
  <svg
    aria-hidden="true"
    focusable="false"
    width="30"
    height="30"
    viewBox="0 0 24 24"
    style={{
      transition: 'transform 180ms ease',
      transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
    }}
  >
    <path
      d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z"
      fill="currentColor"
    />
  </svg>
);

const FAQItem = ({ idBase, index, q, a, expanded, onToggle }) => {
  const buttonId = `${idBase}-faq-button-${index}`;
  const panelId = `${idBase}-faq-panel-${index}`;

  return (
    <div className="faq-item border rounded-3 mb-2">
      <h3 className="m-0">
        <button
          id={buttonId}
          className="faq-trigger w-100 d-flex align-items-center justify-content-between text-start p-3 border-0 bg-white"
          aria-expanded={expanded}
          aria-controls={panelId}
          onClick={onToggle}
        >
          <span className="pe-3">{q}</span>
          <Chevron expanded={expanded} />
        </button>
      </h3>

      <div
        id={panelId}
        role="region"
        aria-labelledby={buttonId}
        hidden={!expanded}
        className="faq-panel px-3 pb-3"
      >
        <p className="mb-0">{a}</p>
      </div>
    </div>
  );
};

const ERidesFAQ = () => {
  const [open, setOpen] = useState(() => new Set([0, 1]));
  const idBase = useRef(
    `faq-${Math.random().toString(36).slice(2, 9)}`
  ).current;

  const toggle = (i) =>
    setOpen((prev) => {
      const next = new Set(prev);
      next.has(i) ? next.delete(i) : next.add(i);
      return next;
    });

  return (
    <section
      className="erides-bikemap-faq-container container"
      aria-label="ERides Bike Map FAQ"
    >
      <div className="faq-title">
        <h2 className="mb-2">
          <FormattedMessage
            id="erides.bikemap.faqTitle"
            defaultMessage="Get Around Austin - Your Way"
          />
        </h2>
      </div>

      <div className="faq-list mt-4">
        {FAQ_DATA.map((item, i) => (
          <FAQItem
            key={i}
            idBase={idBase}
            index={i}
            q={item.q}
            a={item.a}
            expanded={open.has(i)}
            onToggle={() => toggle(i)}
          />
        ))}
      </div>

      <style>{`
        .faq-item:hover .faq-trigger { background-color: #f8f9fa; }
        .faq-trigger { font-size: 1rem; }
        .faq-panel { background-color: #fff; }
      `}</style>
    </section>
  );
};

export default ERidesFAQ;
